module.exports = __webpack_public_path__ + "static/TFF_Cassowary-1146c21ee4f4ba4243c0b12b6b4fa18d.jpg";